import UI from 'root/ui';
import Cache from 'root/cache';
import View from 'view/base';
import View_Menu from 'page/account/menu';
import View_Connected_App_Oauth from 'view/connected_app/oauth';
import View_Connected_App_Jira from 'view/connected_app/jira';
import View_Connected_App_Trello from 'view/connected_app/trello';
import View_Connected_App_Teamwork from 'view/connected_app/teamwork';
import View_Connected_App_Monday from 'view/connected_app/monday';

export default View.extend({
    tagName: 'section',

    views: {
        menu                   : {},
        connected_app_oauth    : {},
        connected_app_jira     : {},
        connected_app_trello   : {},
        connected_app_teamwork : {},
        connected_app_monday   : {}
    },

    event_handlers: {
        onRemove: function(app_type, model) {
            switch (app_type) {
                case 'jira':
                    this.views.connected_app_jira['_' + model.id].remove();
                    delete this.views.connected_app_jira['_' + model.id];
                    break;
                case 'trello':
                    this.views.connected_app_trello['_' + model.id].remove();
                    delete this.views.connected_app_trello['_' + model.id];
                    break;
                case 'teamwork':
                    this.views.connected_app_teamwork['_' + model.id].remove();
                    delete this.views.connected_app_teamwork['_' + model.id];
                    break;
                case 'monday':
                    this.views.connected_app_monday['_' + model.id].remove();
                    delete this.views.connected_app_monday['_' + model.id];
                    break;
                case 'oauth':
                    this.views.connected_app_oauth['_' + model.id].remove();
                    delete this.views.connected_app_oauth['_' + model.id];
                    break;
            }
        }
    },

    initialize: function() {
        this.views.menu = new View_Menu();
    },

    onPageReady: function() {
        // sort by create time
        var apps = [];

        // jira
        Cache.connected_app_jira.each((model) => {
            apps.push({
                model: model,
                view_constructor: View_Connected_App_Jira,
                view_container: this.views.connected_app_jira
            });
        });

        // trello
        Cache.connected_app_trello.each((model) => {
            apps.push({
                model: model,
                view_constructor: View_Connected_App_Trello,
                view_container: this.views.connected_app_trello
            });
        });

        // teamwork
        Cache.connected_app_teamwork.each((model) => {
            apps.push({
                model: model,
                view_constructor: View_Connected_App_Teamwork,
                view_container: this.views.connected_app_teamwork
            });
        });

        // monday
        Cache.connected_app_monday.each((model) => {
            apps.push({
                model: model,
                view_constructor: View_Connected_App_Monday,
                view_container: this.views.connected_app_monday
            });
        });

        // oauth
        Cache.connected_app_oauth.each((model) => {
            apps.push({
                model: model,
                view_constructor: View_Connected_App_Oauth,
                view_container: this.views.connected_app_oauth
            });
        });

        apps.sort((a, b) => {
            if (a.model.get('create_time') < b.model.get('create_time')){
                return 1;
            } else if (a.model.get('create_time') > b.model.get('create_time')){
                return -1;
            } else {
                return 0;
            }
        });

        apps.forEach((app) => {
            app.view_container['_' + app.model.id] = new app.view_constructor({model: app.model});
            app.view_container['_' + app.model.id].render().$el.appendTo(this.$el.find('.region-app'));
        });

        this.listenTo(Cache.connected_app_jira, 'remove', (model) => {
            this.event_handlers.onRemove.call(this, 'jira', model);
        });

        this.listenTo(Cache.connected_app_trello, 'remove', (model) => {
            this.event_handlers.onRemove.call(this, 'trello', model);
        });

        this.listenTo(Cache.connected_app_teamwork, 'remove', (model) => {
            this.event_handlers.onRemove.call(this, 'teamwork', model);
        });

        this.listenTo(Cache.connected_app_monday, 'remove', (model) => {
            this.event_handlers.onRemove.call(this, 'monday', model);
        });

        this.listenTo(Cache.connected_app_oauth, 'remove', (model) => {
            this.event_handlers.onRemove.call(this, 'oauth', model);
        });
    },

    render: function() {
        UI.setPageTitle('Connected Apps');

        var content =
        '<main class="xlarge">' +
            '<div class="region-app"></div>' +
            '<div class="region-empty">' +
                '<div class="search-result-empty active margin-top-24">' +
                    '<p class="text-regular">You have not connected any apps. <a href="https://support.userback.io/en/collections/9575464" class="primary" target="help" rel="noopener">Find out how to connect integrations <i class="fa-solid fa-square-arrow-up-right"></i></a></p>' +
                '</div>' +
            '</div>' +


        '</main>';

        this.$el.html(content);

        this.views.menu.render().$el.prependTo(this.$el.find('main'));

        return this;
    }
});